import './App.css';
import { CssBaseline, ThemeProvider, IconButton } from '@mui/material';
import { SnackbarProvider, closeSnackbar } from 'notistack';
import CloseIcon from '@mui/icons-material/Close';
import { useState, useMemo, useEffect } from 'react';
import { getTheme } from './theme/theme';
import AppRoutes from './routes/AppRoutes';
import { useVersionCheck } from './hooks/useVersionCheck';
import { usePathname } from './routes/hooks/use-pathname';
import ReactGA from 'react-ga4'; // 👈 1. Import the library

// 👈 2. Initialize GA with your ID (outside the component)
ReactGA.initialize("G-4B0D1WCHHP");

function useScrollToTop() {
  const pathname = usePathname();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// 👈 3. Create a custom hook for Tracking (Clean & keeps concerns separate)
function usePageTracking() {
  const pathname = usePathname();

  useEffect(() => {
    // Send pageview whenever the path changes
    ReactGA.send({ hitType: "pageview", page: pathname });
  }, [pathname]);
}

const App = () => {
  useScrollToTop();
  useVersionCheck();
  usePageTracking(); // 👈 4. Call the hook here

  const [mode, setMode] = useState<'light' | 'dark'>('light');
  const theme = useMemo(() => getTheme(mode), [mode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider
        maxSnack={3}
        autoHideDuration={null}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        action={(snackbarId) => (
          <IconButton
            size="small"
            onClick={() => closeSnackbar(snackbarId)}
            color="inherit"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        )}
      >
        <AppRoutes mode={mode} setMode={setMode} />
      </SnackbarProvider>
    </ThemeProvider>
  );
};

export default App;